import { Row, Col, Card, Table, Button, Input, Tooltip, Switch, Modal, Tag, Spin, Divider, Typography } from "antd";
import React, { useState, useEffect, useRef } from "react";
import TagList from "../../components/TagList";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import ShowTotal from "../../components/ShowTotal";
import ConfirmationBox from "../../components/ConfirmationBox";
import apiPath from "../../constants/apiPath";
import moment from 'moment';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import From from "./From";
import { getSortOrder } from "../../constants/conts";
import { EyeIcon, PencilLineIcon, Trash2 } from "lucide-react";
const Search = Input.Search;

function Index() {

  const sectionName = "Vehicle Manufacturer";
  const routeName = "vehicle-manufacturer";

  const api = {
    status: apiPath.statusVehicleManufacturer,
    addEdit: apiPath.addEditVehicleManufacturer,
    list: apiPath.listVehicleManufacturer,
    delete: apiPath.deleteVehicleManufacturer,
    view: apiPath.viewVehicleManufacturer,
  }

  const [searchText, setSearchText] = useState('');
  const { request } = useRequest()
  const [list, setList] = useState([])
  const { showConfirm } = ConfirmationBox()
  const [loading, setLoading] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20 });
  const [sortBy, setSortBy] = useState('');
  const lastFiltersRef = useRef({});
  const debouncedSearchText = useDebounce(searchText, 300);
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState();
  const [viewVisible, setViewVisible] = useState(false);
  const [viewData, setViewData] = useState(null);
  const [viewLoading, setViewLoading] = useState(false);

  const columns = [
    {
      title: "En Name",
      dataIndex: "en_name",
      key: "en_name",
      sorter: true,
      sortOrder: getSortOrder(sortBy, "en_name"),
      render: (_, { en_name, en_display_name }) => {
        return (
          <div>
            <div className="cap font-medium"> {en_name || "-"} </div>
            <div className="cap"> {en_display_name || ""} </div>
          </div>
        );
      },
    },
    {
      title: "Hi Name",
      dataIndex: "hi_name",
      key: "hi_name",
      sorter: true,
      sortOrder: getSortOrder(sortBy, "hi_name"),
      render: (_, { hi_name, hi_display_name }) => {
        return (
          <div>
            <div className="cap font-medium"> {hi_name || "-"} </div>
            <div className="cap"> {hi_display_name || ""} </div>
          </div>
        );
      },
    },
    {
      title: "Gj Name",
      dataIndex: "gj_name",
      key: "gj_name",
      sorter: true,
      sortOrder: getSortOrder(sortBy, "gj_name"),
      render: (_, { gj_name, gj_display_name }) => {
        return (
          <div>
            <div className="cap font-medium"> {gj_name || "-"} </div>
            <div className="cap"> {gj_display_name || ""} </div>
          </div>
        );
      },
    },
    {
      title: "Segments",
      key: "segments",
      render: (_, { segments }) => <TagList items={segments} color="blue" />,
    },
    {
      title: "Status",
      key: "is_active",
      filters: [
        {
          text: 'Active',
          value: true,
        },
        {
          text: 'Inactive',
          value: false,
        },
      ],
      render: (_, { is_active, _id }) => {
        return (
          <Switch
            checked={is_active}
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            loading={loading}
            onChange={(checked) =>
              showConfirm({
                record: _id,
                path: api.status,
                // onLoading: () => setLoading(true),
                onSuccess: () => setRefresh((prev) => !prev),
                is_active: checked,
              })
            }
            className={is_active ? "custom-switch-checked" : "custom-switch-unchecked"}
          />
        );
      },
    },
    {
      title: "Created On",
      key: "created_at",
      dataIndex: "created_at",
      sorter: true,
      sortOrder: getSortOrder(sortBy, "created_at"),
      render: (_, { created_at }) => {
        return (
          moment(created_at).format('DD-MMM-YYYY')
        );
      },
    },
    {
      title: "Action",
      fixed: 'right',
      render: (_, record) => {
        return (
          <>
            <Tooltip title={"View " + sectionName} color={"blue"} key={"view" + routeName}>
              <Button
                className="mr-2"
                onClick={() => {
                  setViewVisible(true);
                  setViewLoading(true);
                  request({
                    url: api.view + "/" + record._id,
                    method: 'GET',
                    onSuccess: (res) => {
                      setViewData(res.data);
                      setViewLoading(false);
                    },
                    onError: (err) => {
                      ShowToast(err, Severty.ERROR);
                      setViewLoading(false);
                    },
                  });
                }}
              >
                <EyeIcon size={15} />
              </Button>
            </Tooltip>

            <Tooltip title={"Update " + sectionName} color={"purple"} key={"update" + routeName}>
              <Button onClick={() => {
                setSelected(record)
                setVisible(true)
              }}>
                <PencilLineIcon size={15} />
              </Button>
            </Tooltip>
            
            <Tooltip title={"Delete " + sectionName} color={"red"} key={"delete" + routeName}>
              <Button
                danger
                onClick={() =>
                  showConfirm({
                    record: record._id,
                    path: api.delete,
                    method: 'DELETE',
                    onSuccess: () => setRefresh((prev) => !prev),
                    title: `Are you sure you want to delete this ${sectionName}?`,
                    content: "This action cannot be undone.",
                    okButtonProps: { danger: true }
                  })
                }
              >
                <Trash2 size={15} />
              </Button>
            </Tooltip>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    setLoading(true)
    fetchData(pagination, lastFiltersRef.current, sortBy)
  }, [refresh, debouncedSearchText, sortBy, pagination.current, pagination.pageSize])

  const fetchData = (pagination, filters, sortValue = '') => {

    const filterActive = filters ? filters.is_active : null;

    request({
      url:
        api.list +
        `?status=${filterActive ? filterActive.join(',') : ''}` +
        `&page=${pagination.current}` +
        `&limit=${pagination.pageSize}` +
        `&search=${debouncedSearchText}` +
        `&sort=${sortValue || ''}`,
      method: 'GET',
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data.list.docs);
        setPagination(prev => ({
          ...prev,
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: data.data.list.totalDocs,
        }));
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  }

  const handleChange = (pag, filters, sorter) => {
    const { order, field } = sorter || {};

    let nextSort = '';
    if (order) {
      nextSort = `${field}:${order === 'ascend' ? 'asc' : 'desc'}`;
    }

    lastFiltersRef.current = filters || {};

    setSortBy(nextSort);

    setPagination(prev => ({
      ...prev,
      current: pag?.current || 1,
      pageSize: pag?.pageSize || prev.pageSize,
    }));
  };

  const onSearch = (e) => {
    setSearchText(e.target.value)
    setPagination(prev => ({ ...prev, current: 1 }));
  };

  return (
    <>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              variant={false}
              className="criclebox tablespace mb-24"
              title={sectionName + " Management"}
              extra={
                <>
                  <Search
                    allowClear
                    size="large"
                    onChange={onSearch}
                    value={searchText}
                    onPressEnter={onSearch}
                    placeholder="Search By English Name"
                  />
                  <Button onClick={(e) => { setVisible(true); setSearchText(''); }}>Add New {sectionName}</Button>
                </>
              }
            >
              <h4 className="text-right mb-1">{pagination.total ? ShowTotal(pagination.total) : ShowTotal(0)}</h4>
              <div className="table-responsive customPagination">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total: pagination.total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    responsive: true,
                    defaultPageSize: 20,
                    pageSizeOptions: ['10', '20', '30', '50', '100']
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      {/* Add Modal */}
      {visible &&
        <From
          path={api.addEdit}
          sectionName={sectionName}
          show={visible}
          hide={() => { setSelected(); setVisible(false) }}
          data={selected}
          refresh={() => {
            setRefresh(prev => !prev)
          }}
        />
      }

      {/* View Modal */}
      <Modal
        open={viewVisible}
        title="Vehicle Manufacturer Details"
        onCancel={() => { setViewVisible(false); setViewData(null); }}
        width={600}
        footer={<Button onClick={() => { setViewVisible(false); setViewData(null); }}>Cancel</Button>}
        styles={{ body: { maxHeight: '65vh', overflowY: 'auto' } }}
      >
        {viewLoading ? (
          <div className="text-center p-5"><Spin /></div>
        ) : viewData ? (
          <>
            <Row gutter={[4, 16]}>
              <Col span={12}>
                <Typography.Text type="secondary">English Name</Typography.Text>
                <div className="font-medium">{viewData.en_name || '-'}</div>
              </Col>
              <Col span={12}>
                <Typography.Text type="secondary">English Display Name</Typography.Text>
                <div className="font-medium">{viewData.en_display_name || '-'}</div>
              </Col>
              <Col span={12}>
                <Typography.Text type="secondary">Hindi Name</Typography.Text>
                <div className="font-medium">{viewData.hi_name || '-'}</div>
              </Col>
              <Col span={12}>
                <Typography.Text type="secondary">Hindi Display Name</Typography.Text>
                <div className="font-medium">{viewData.hi_display_name || '-'}</div>
              </Col>
              <Col span={12}>
                <Typography.Text type="secondary">Gujarati Name</Typography.Text>
                <div className="font-medium">{viewData.gj_name || '-'}</div>
              </Col>
              <Col span={12}>
                <Typography.Text type="secondary">Gujarati Display Name</Typography.Text>
                <div className="font-medium">{viewData.gj_display_name || '-'}</div>
              </Col>
              <Col span={12}>
                <Typography.Text type="secondary">Status</Typography.Text>
                <div><Tag color={viewData.is_active ? 'green' : 'red'}>{viewData.is_active ? 'Active' : 'Inactive'}</Tag></div>
              </Col>
              <Col span={12}>
                <Typography.Text type="secondary">Created On</Typography.Text>
                <div>{viewData.created_at ? moment(viewData.created_at).format('DD-MMM-YYYY, hh:mm A') : '-'}</div>
              </Col>
            </Row>

            <Divider />

            <div>
              <Typography.Text type="secondary">Segments</Typography.Text>
              <div className="mt-1">
                {viewData.segment_ids && viewData.segment_ids.length > 0
                  ? viewData.segment_ids.map((seg) => <Tag key={seg._id} color="blue" className="mb-1">{seg.en_name}</Tag>)
                  : <Typography.Text type="secondary">No segments assigned</Typography.Text>
                }
              </div>
            </div>
          </>
        ) : null}
      </Modal>
    </>
  );
}

export default Index;
